import { useQuery } from "@tanstack/react-query";
import { ApiError } from "../../api/client";
import { adminApi } from "../../api/admin";
import { useMe } from "./useMe";

export type StaffRole = "support" | "admin" | "owner" | null;

const ORDER: Record<Exclude<StaffRole, null>, number> = {
  support: 0,
  admin: 1,
  owner: 2,
};

export function roleAtLeast(
  role: StaffRole,
  minimum: Exclude<StaffRole, null>,
): boolean {
  return role !== null && ORDER[role] >= ORDER[minimum];
}

/** The current user's staff role (null for non-staff). Reads /admin/staff, which support may list. */
export function useStaff() {
  const me = useMe();
  const query = useQuery<StaffRole>({
    queryKey: ["staff-role", me.data?.id ?? null],
    enabled: !!me.data,
    queryFn: async () => {
      try {
        const rows = await adminApi.staff();
        return rows.find((r) => r.user_id === me.data?.id)?.role ?? null;
      } catch (err) {
        if (
          err instanceof ApiError &&
          (err.status === 403 || err.status === 401)
        )
          return null;
        throw err;
      }
    },
    staleTime: 60_000,
  });
  return {
    role: me.data ? (query.data ?? null) : null,
    isLoading: me.isLoading || query.isLoading,
  };
}
